<template>
  <v-container fluid :dark="isDark" :class="colorClass">
    <div class="text-validation">
      <div>
        <v-text-field
          :dark="isDark"
          :class="colorClass"
          label="Ingresso"
          type="tel"
          v-model="ticket"
          required
          autofocus
          @keyup.enter="submit"
        ></v-text-field>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      ticket: ''
    }
  },
  computed: {
    eventId() {
      return this.$store.getters.selectedEvent.id
    },
    colorClass() {
      return this.$store.getters.colorClass
    },
    isDark() {
      return this.$store.getters.isDark
    }
  },
  methods: {
    submit() {
      if (this.ticket.includes('wixevents.com')) {
        const ticketRegex = this.ticket.match(/[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]*/gm)
        this.ticket = ticketRegex[0]
      }
      this.$store.dispatch('readTicket', { ticket: this.ticket, eventId: this.eventId })
      this.ticket = ''
    }
  }
}
</script>

<style scoped>
.text-validation {
  height: 82vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/validation/TextValidation.vue